import { ENUM_FIN_FOR_COMP_PLAN } from 'components/pages/financing-for-companies/base/enumsFinForComp';
import MarkLegendItem from 'components/pages/financing-for-companies/items/MarkLegendItem';
import { filter } from 'ramda';
import React from 'react';
import tw from 'twin.macro';

export default function Plan({ rows, categoriesList, planNumber, isGreen, ...props }) {
	const planList = categoriesList.map(categoryName => filter(item => item.category.name === categoryName, rows));

	return (
		<div tw='h-full w-90 xl:w-120 relative rounded-10 bg-grey-F mx-03 sm:mx-05 flex flex-col items-center' {...props}>
			<div className='absolute left-50/100 top-0'>
				<div
					css={[
						tw`relative -left-50/100 w-30 h-03 bg-gradient-to-r rounded-b-xl`,
						isGreen ? tw`from-green-7 to-green-3` : tw`from-grey-blue-E to-grey-blue-B`
					]}
				/>
			</div>

			<p className='text-12 font-bold mt-20 mb-25'>{ENUM_FIN_FOR_COMP_PLAN[planNumber]}</p>
			{categoriesList.map(categoryName => (
				<div key={categoryName} className='mb-24'>
					{planList.find(listByCategory => listByCategory[0].category.name === categoryName).map(item => {
						switch (planNumber) {
						// ENUM_FIN_FOR_COMP_PLAN.FINTEQ
							case 0: return <p className='h-30 ml-05 flex items-center'><MarkLegendItem value={item.finteqValue} /></p>;
								// ENUM_FIN_FOR_COMP_PLAN.CREDIT
							case 1: return <p className='h-30 ml-05 flex items-center'><MarkLegendItem value={item.creditValue} /></p>;
								// ENUM_FIN_FOR_COMP_PLAN.FACTORING
							case 2: return <p className='h-30 ml-05 flex items-center'><MarkLegendItem value={item.factoringValue} /></p>;
								// ENUM_FIN_FOR_COMP_PLAN.LOAN
							case 3: return <p className='h-30 ml-05 flex items-center'><MarkLegendItem value={item.loanValue} /></p>;
							// ENUM_FIN_FOR_COMP_PLAN.FINTEQ
							default: return <p className='h-30 ml-05 flex items-center'><MarkLegendItem value={item.finteqValue} /></p>;
						}
					})}
				</div>
			))}
			{/*<div className=''>*/}
			{/*	{configTable?.map(item => {*/}
			{/*		return (*/}
			{/*			<div style={{ marginTop: '0.37rem' }}>*/}
			{/*				{listByCategory.map(item => {*/}
			{/*					return <p key={item.name} className='h-30 ml-05 flex items-center'>O</p>;*/}
			{/*				})}*/}
			{/*				<div className='w-20 h-20' />*/}
			{/*			</div>*/}
			{/*		);*/}
			{/*	})}*/}
			{/*</div>*/}

			{/*/!*program*!/*/}
			{/*{plan?.configCategories?.map(configCategory => (*/}
			{/*	<p className='h-28'>{PRICING_PLAN_OPTION_CATEGORY[configCategory]}</p>*/}
			{/*))}*/}

			{/*/!*suppliers*!/*/}

			{/*/!*helpdesk*!/*/}

			{/*/!*options*!/*/}
		</div>
		// <div {...props}>
		// 	<p className="ml-05 h-12 mt-12 font-bold">{categoryName}</p>
		// 	{listByCategory.map(item => (
		// 		<p key={item.name} className='h-30 ml-05 flex items-center'>OOO</p>
		// 	))}
		// </div>
	);
}
